(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Scrolling-logos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  window.onhowScrollingLogos = window.onhowScrollingLogos || {};

  window.onhowScrollingLogos.initializedSections = window.onhowScrollingLogos.initializedSections || {};

  window.onhowScrollingLogos.pendingTimeouts = window.onhowScrollingLogos.pendingTimeouts || {};

  window.onhowScrollingLogos.lastResize = window.onhowScrollingLogos.lastResize || 0;

  let hasInitialized = false;

  function initializeSections() {
    if (hasInitialized) {
      return;
    }

    hasInitialized = true;

    for (let id in window.onhowScrollingLogos.pendingTimeouts) {
      clearTimeout(window.onhowScrollingLogos.pendingTimeouts[id]);
    }

    window.onhowScrollingLogos.pendingTimeouts = {};

    const sections = document.querySelectorAll('.onhow-scrolling-logos-section');

    sections.forEach((section) => {
      const sectionId = section.id || `section-${Math.random().toString(36).substr(2, 9)}`;

      if (window.onhowScrollingLogos.initializedSections[sectionId]) {
        return;
      }

      window.onhowScrollingLogos.initializedSections[sectionId] = true;

      window.onhowScrollingLogos.pendingTimeouts[sectionId] = setTimeout(() => {
        initSection(section);
        delete window.onhowScrollingLogos.pendingTimeouts[sectionId];
      }, 200);
    });
  }

  async function initSection(section) {
    const track = section.querySelector('.onhow-scrolling-logos-track');
    if (!track) return;

    track.classList.remove('onhow-initialized');

    await preloadImages(track);

    setupTrack(track);
  }

  function handleResize() {
    const now = Date.now();
    if (now - window.onhowScrollingLogos.lastResize < 1000) {
      return;
    }

    const sections = document.querySelectorAll('.onhow-scrolling-logos-section');
    let shouldReinitialize = false;

    sections.forEach((section) => {
      const track = section.querySelector('.onhow-scrolling-logos-track');
      if (!track) return;

      const container = track.parentElement;
      const currentWidth = container.offsetWidth;
      const storedWidth = parseFloat(section.getAttribute('data-last-width') || '0');

      if (storedWidth === 0) {
        section.setAttribute('data-last-width', currentWidth);
        return;
      }

      if (Math.abs(currentWidth - storedWidth) > 20) {
        shouldReinitialize = true;
        section.setAttribute('data-last-width', currentWidth);
      }
    });

    if (shouldReinitialize) {
      window.onhowScrollingLogos.lastResize = now;
      hasInitialized = false;
      window.onhowScrollingLogos.initializedSections = {};
      initializeSections();
    }
  }

  function preloadImages(track) {
    return new Promise((resolve) => {
      const images = track.querySelectorAll('img');
      let loadedCount = 0;
      const totalImages = images.length;

      if (totalImages === 0) {
        resolve();
        return;
      }

      const checkComplete = () => {
        loadedCount++;
        if (loadedCount >= totalImages) {
          resolve();
        }
      };

      images.forEach(img => {
        if (img.complete) {
          checkComplete();
          return;
        }

        const tempImg = new Image();
        tempImg.onload = checkComplete;
        tempImg.onerror = checkComplete;
        tempImg.src = img.src;
      });
    });
  }

  function setupTrack(track) {
    const inner1 = track.querySelector('.onhow-scrolling-logos-inner--1');
    const inner2 = track.querySelector('.onhow-scrolling-logos-inner--2');

    if (!inner1 || !inner2) return;

    const section = track.closest('.onhow-scrolling-logos-section');
    const containerWidth = track.parentElement.offsetWidth;
    section.setAttribute('data-last-width', containerWidth);

    inner1.style.animation = 'none';
    inner2.style.animation = 'none';
    void inner1.offsetWidth;
    void inner2.offsetWidth;

    // FIX: Cache the TRUE original items the first time we run setupTrack for
    // this track element. On later re-runs (window resize), inner1 already
    // contains post-duplication items, and treating those as originals would
    // multiply originalWidth and make the scroll speed compound on every
    // resize. The cache guarantees we always measure from the true originals.
    //
    // We cache detached cloneNode copies (not HTML strings) so measurement
    // behavior exactly matches the original code's cloneNode-based flow.
    if (!track._onhowOriginalItems) {
      const initialItems = inner1.querySelectorAll('.onhow-logo-item');
      if (initialItems.length === 0) return;
      track._onhowOriginalItems = Array.from(initialItems).map(item => item.cloneNode(true));
    }

    const originalItemsCache = track._onhowOriginalItems;
    if (!originalItemsCache || originalItemsCache.length === 0) return;

    // Rebuild inner1 from the cached originals only; clear inner2 completely.
    // Clone the cache nodes so the cache stays pristine for future re-inits.
    inner1.innerHTML = '';
    inner2.innerHTML = '';

    originalItemsCache.forEach(item => {
      inner1.appendChild(item.cloneNode(true));
    });

    const measuredItems = inner1.querySelectorAll('.onhow-logo-item');
    const originalWidth = Array.from(measuredItems).reduce((sum, item) => {
      const style = window.getComputedStyle(item);
      return sum + item.offsetWidth +
             parseFloat(style.marginLeft) +
             parseFloat(style.marginRight);
    }, 0);

    const originalCount = measuredItems.length;
    track.setAttribute('data-original-count', originalCount);

    const baseScrollSpeed = parseFloat(section.getAttribute('data-scroll-speed')) || 60;

    // SPEED AMPLIFIER: Multiplying by this constant makes every slider value
    // scroll that many times faster than the raw value would imply. Bump it up
    // for a faster overall range, down for slower.
    const SPEED_AMPLIFIER = 3;

    // CALIBRATION_COUNT: The logo count the slider is calibrated against
    // (matches the default preset of 6). Normalizing against this keeps the
    // visual px/sec scroll speed independent of how many logos the merchant
    // adds. Without this, originalWidth grows with each new logo block,
    // inflating desiredPxPerSec and making the scroll accelerate as more
    // logos are added. Using the average per-logo width × a fixed baseline
    // count makes adding/removing logos a cosmetic change, not a speed change.
    const CALIBRATION_COUNT = 6;
    const averageLogoWidth = originalWidth / Math.max(1, originalCount);
    const desiredPxPerSec = (averageLogoWidth * CALIBRATION_COUNT * SPEED_AMPLIFIER) / baseScrollSpeed;

    const containerWidthForCalc = track.parentElement.offsetWidth;

    const minTargetWidth = containerWidthForCalc * 3;

    const duplicatesNeeded = Math.max(1, Math.ceil(minTargetWidth / originalWidth) - 1);

    // Re-clone from the pristine cache (not from items now attached to inner1)
    // so we have a clean source for the duplication passes below.
    const clonedItems = originalItemsCache.map(item => item.cloneNode(true));

    for (let i = 0; i < duplicatesNeeded; i++) {
      clonedItems.forEach(item => {
        inner1.appendChild(item.cloneNode(true));
        inner2.appendChild(item.cloneNode(true));
      });
    }

    clonedItems.forEach(item => {
      inner2.appendChild(item.cloneNode(true));
    });

    const finalWidth = originalWidth * (duplicatesNeeded + 1);

    inner1.style.width = `${finalWidth}px`;
    inner2.style.width = `${finalWidth}px`;

    inner2.style.transform = `translateX(${finalWidth}px)`;

    const adjustedDuration = finalWidth / desiredPxPerSec;

    track.setAttribute('data-original-width', originalWidth.toFixed(2));
    track.setAttribute('data-final-width', finalWidth.toFixed(2));
    track.setAttribute('data-base-speed', baseScrollSpeed);
    track.setAttribute('data-adjusted-duration', adjustedDuration.toFixed(2));

    setTimeout(() => {
      inner1.style.animation = `onhow-scroll-1 ${adjustedDuration}s linear infinite`;
      inner2.style.animation = `onhow-scroll-2 ${adjustedDuration}s linear infinite`;

      track.classList.add('onhow-initialized');
    }, 50);
  }

  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSections);
  } else {
    initializeSections();
  }

  window.addEventListener('load', initializeSections);

  window.addEventListener('resize', debounce(handleResize, 500));

  // FIX: Shopify theme editor re-renders the section HTML whenever a setting
  // changes (speed slider, padding, etc.). The freshly-injected section needs
  // to be initialized, otherwise its track stays at opacity:0 / visibility:
  // hidden and the logos appear to "disappear" in the preview pane. We listen
  // for Shopify's section:load event and init the new section directly, which
  // bypasses the module-scoped hasInitialized guard used on page load.
  document.addEventListener('shopify:section:load', function(event) {
    if (!event.target) return;
    const section = event.target.querySelector('.onhow-scrolling-logos-section');
    if (section) {
      initSection(section);
    }
  });

  // Also re-init on section:select so if a user clicks back onto a section
  // whose animation was interrupted, it comes back cleanly.
  document.addEventListener('shopify:section:reorder', function(event) {
    if (!event.target) return;
    const section = event.target.querySelector('.onhow-scrolling-logos-section');
    if (section) {
      initSection(section);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
